import { useQuery } from '@apollo/client';
import { useMemo } from 'react';

import ClientVisibleTaskResources from '@components/ClientVisibleTaskResources';
import HandleQuery from '@components/HandleQuery';
import ExpertJourneyPage from '@components/pageTypes/ExpertJourneyPage';
import {
  GetJourneyWithClientVisibleTasksDocument,
  GetJourneyWithClientVisibleTasksQuery,
  GetJourneyWithClientVisibleTasksQueryVariables
} from '@typing/Generated';

type Props = {
  journeyId: string;
  taskId: string;
};

const ExpertJourneyClientVisibleTaskPage = ({ journeyId, taskId }: Props) => {
  const getJourneyQuery = useQuery<
    GetJourneyWithClientVisibleTasksQuery,
    GetJourneyWithClientVisibleTasksQueryVariables
  >(GetJourneyWithClientVisibleTasksDocument, {
    variables: {
      id: journeyId
    }
  });

  const clientVisibleTask = useMemo(
    () => getJourneyQuery.data?.journey.clientVisibleTasks.find(task => task.id === taskId),
    [getJourneyQuery.data?.journey.clientVisibleTasks, taskId]
  );

  return (
    <ExpertJourneyPage
      gradient={false}
      helmetKey="pageTitles.expertJourney.clientVisibleTask.show"
      journeyId={journeyId}
    >
      <HandleQuery query={getJourneyQuery}>
        {journeyData => (
          <>
            {clientVisibleTask && <ClientVisibleTaskResources journey={journeyData.journey} task={clientVisibleTask} />}
          </>
        )}
      </HandleQuery>
    </ExpertJourneyPage>
  );
};

export default ExpertJourneyClientVisibleTaskPage;
